import { type Meta } from '../types/docs';

const META: Meta = {
  name: 'downloaded_transcript',
  description: 'Called when user clicks "Download vtt" or "Download srt" option',
  params: [
    {
      name: 'clip_id',
      description: 'The ID of clip',
      required: true,
      type: 'string',
    },
    {
      name: 'file_type',
      description: 'Type of file downloaded',
      required: true,
      type: 'enum',
      values: ['vtt', 'srt'],
    },
  ],
};

export default META;
